import { useContext, useContextSelector } from 'use-context-selector';
import { MediaStateContextLite } from '../media-state-provider-lite';
export const useMediaStateLite = () => {
  return useContext(MediaStateContextLite);
};
export const useMediaStateLiteOnPlayStatusChange = () => {
  return useContextSelector(MediaStateContextLite, s => s.onPlayStatusChange);
};
export const useMediaStateLiteResetMediaState = () => {
  return useContextSelector(MediaStateContextLite, s => s.resetMediaState);
};
export const useMediaStateLiteOnSeekToFrame = () => {
  return useContextSelector(MediaStateContextLite, s => s.onSeekToFrame);
};
export const useMediaStateLiteMediaElement = () => {
  return useContextSelector(MediaStateContextLite, s => s.mediaElement);
};